import $ from 'jquery';
import { closeModal } from '@/function/function.js';

export default {
    name: 'todo-create',
    components: {},
    props: [],
    data () {
        return {
            loading: false
        }
    },
    computed: {

    },
    mounted () {

    },
    methods: {
        async submitForm() {
            this.loading=true;
        },

        async onTextChange() {
            var key = window.event.keyCode;
            console.log("-->")

            // If the user has pressed enter
            if (key === 13) {
                document.getElementById("txtArea").value = document.getElementById("txtArea").value + "\n*";
                console.log(" --> ",$("#txtArea").val());

                $('.modal').modal('hide');
                return false;
            }
            else {
                return true;
            }
        },

        /**
         * Close Modal
         * @param {*} selector 
        */
        closeModal(selector) 
        {
            closeModal.closeModal(selector);
        }
    }
}


